var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogosJavascript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 71,
    viewBox: "0 0 84 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.3823 1H21.8721C12.0016 1 4 8.2684 4 17.2344V54.0325C4 62.9985 12.0016 70.2669 21.8721 70.2669H62.3823C72.2528 70.2669 80.2544 62.9985 80.2544 54.0325V17.2344C80.2544 8.2684 72.2528 1 62.3823 1Z",
    fill: "#F0DB4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0502 58.8844L29.8854 55.6765C31.0114 57.4896 32.0354 59.0237 34.4919 59.0237C36.8466 59.0237 38.3312 58.1871 38.3312 54.9327V32.8003H45.4973V55.0247C45.4973 61.7666 41.1466 64.8354 34.7991 64.8354C29.0666 64.8354 25.7391 62.1386 24.0499 58.8839M49.3896 58.1869L55.2242 55.1183C56.7603 57.3968 58.7566 59.0706 62.2882 59.0706C65.2576 59.0706 67.1509 57.722 67.1509 55.8621C67.1509 53.6304 65.2058 52.8398 61.9298 51.5383L60.1387 50.8405C54.9686 48.8415 51.539 46.3306 51.539 41.03C51.539 36.1478 55.6341 32.4279 62.0326 32.4279C66.5882 32.4279 69.8641 33.8696 72.2185 37.6357L66.6391 40.8904C65.4104 38.8911 64.0801 38.1008 62.0326 38.1008C59.9338 38.1008 58.6029 39.3097 58.6029 40.8904C58.6029 42.8432 59.9338 43.6338 63.0048 44.843L64.7962 45.5402C70.8873 47.9118 74.317 50.3291 74.317 55.769C74.317 61.628 69.2496 64.8359 62.4419 64.8359C55.7878 64.8359 51.488 61.9532 49.3896 58.1869Z",
    fill: "#323330"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosJavascript);
export default __webpack_public_path__ + "static/media/logos_javascript.83d2c2d5af47db246668792f9ee7686d.svg";
export { ForwardRef as ReactComponent };